module.exports = __webpack_public_path__ + "static/media/Front Cover.1f9b03d9.png";